import * as React from 'react';

import * as styles from './styles/notice.css';

interface IProps {
  onClose?(): void;
}

export function Notice({ children, onClose }: React.PropsWithChildren<IProps>) {
  return (
    <div className={styles['wrapper']} onClick={onClose}>
      <div className={styles['notice']}>{children}</div>
    </div>
  );
}
